export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlHCF', function (AonConfig, $scope) {

    let ctrl = $scope.$parent.ctrl;

    // Default these to 'Yes'
    _.set(ctrl.application, 'personal.previous_fund.continuous_cover', 'Y');
    if (Object.keys(ctrl.application.partner)) {
      _.set(ctrl.application, 'partner.previous_fund.continuous_cover', 'Y');
    }

    _.set(ctrl.application, 'payment.join_date', new Date());
    this.joinMinDate = ctrl.join_date_minimum;
    this.joinMaxDate = new Date();
    // 2017-06-019 terry: HCF allows up to 30 days in the past. covermenow doesn't. limit to "today"
    //this.joinMinDate.setDate(this.joinMinDate.getDate() - 30);
    this.joinMaxDate.setDate(this.joinMaxDate.getDate() + 90);

    // Return true if one of the applicants has a previous fund
    this.isSwitchingFunds = () => {
      const primaryApplicantSwitching = _.get(ctrl.application, 'personal.previous_fund.has_previous_fund', false);
      const partnerApplicantSwitching = _.get(ctrl.application, 'partner.previous_fund.has_previous_fund', false);
      return primaryApplicantSwitching || partnerApplicantSwitching;
    };

    // Text for the authority transfer checkbox is different for public vs operator
    this.fundTransferAuthorityText = () => {
      return AonConfig.corporate.is_operator ?
          'Have asked customer if they consent to HCF contacting their current fund to arrange the clearance certificate' :
          'Do you consent for HCF to contact your previous fund to arrange your transfer?';
    };

    this.updateDebitDayOptions = () => {
      // HCF docs:
      // Fortnightly = 1-31
      // All other = 1-27
      //this.debitDayOptions = _.range(1, ctrl.application.payment.frequency == 1 ? 32 : 28);

      // NOTE: temporarily restricting to just 1-27
      this.debitDayOptions = _.range(1, 28);
    }
    this.updateDebitDayOptions();

    this.updateDebitDate = () => {
      let debitDay = _.get(ctrl.application, 'payment.debit_day');
      if (debitDay) {
        let joinDate = _.get(ctrl.application, 'payment.join_date');
        let debitDate = new Date(joinDate);
        let today = new Date();
        debitDate.setDate(debitDay);
        while(today >= debitDate || joinDate > debitDate) {
          debitDate.setMonth(debitDate.getMonth()+1);
        }
        _.set(ctrl.application, 'payment.debit_date', debitDate);
      }
    };

    const benefitPaymentChoices = ctrl.fieldsets.payment.benefit_payment.type.options;
    this.paymentIsBankAccount = () => _.get(ctrl.application, 'payment.type') == 1;
    this.showBenefitAccountDetails = () => _.get(ctrl.application, 'payment.benefit_payment.type') === benefitPaymentChoices.OTHER;
    const updateBenefitAccountOptions = () => {
      if (this.paymentIsBankAccount()) {
        this.benefitAccountOptions = [
          ['Bank account - same details as payment account', benefitPaymentChoices.SAME],
          ['Bank account - different account', benefitPaymentChoices.OTHER],
        ];
      } else {
        this.benefitAccountOptions = [
          ['Bank account', benefitPaymentChoices.OTHER],
        ];
      }
    };
    updateBenefitAccountOptions();
    $scope.$watch('ctrl.application.payment.type', updateBenefitAccountOptions);
    console.log(benefitPaymentChoices, this.benefitAccountOptions)

  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-hcf.js